<template>
  <div class="EarlierInspections">
    <h1 style="font-size: 250%;">Prüfungsintervalle</h1>
    <v-divider></v-divider>
    <v-data-table :headers="headers" :items="inspections" item-key="inspectionID">
      <template slot="item" slot-scope="props">
        <tr>
          <td style="font-size: 120%;">{{props.item.roName}}</td>
          <td style="font-size: 120%;">{{props.item.roType}}</td>
          <td style="font-size: 120%;">{{props.item.facName}}</td>
          <td style="font-size: 120%;">{{new Date(props.item.date).toLocaleDateString(['de-AT'])}}</td>
          <td style="font-size: 120%;">{{props.item.interval}}</td>
          <td>
            <v-btn
              color="blue"
              dark
              @click="$store.commit('setInpectionID', props.item.inspectionID);printPDF();"
              icon
            >
              <v-icon>fas fa-print</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "EarlierInspections",
  data() {
    return {
      dialog: false,
      asd: "",
      inspectionRow: 0,
      headers: [
        { text: "Seilbezeichnung / Norm", align: "center", sortable: false },
        { text: "Seilart", align: "center", sortable: false },
        { text: "Anlagenname", align: "center", sortable: false },
        { text: "Datum", align: "center", sortable: false },
        { text: "Intervall", align: "center", sortable: false },
        { text: "Protokoll herunterladen", align: "center", sortable: false }
      ],
      inspections: [],
      headersAssess: [
        { text: "Kriterium", align: "center", sortable: false },
        { text: "Bewertungstext", align: "center", sortable: false },
        { text: "Bewertung", align: "center", sortable: false }
      ],
      itemsAssess: []
    };
  },
  methods: {
    fillArr(index) {
      var o = this.inspections.find(x => x.inspectionID === index);
      var inspIndex = this.inspections.indexOf(o);
      this.inspections = this.$store.state.inspections;
      this.itemsAssess = [];

      this.itemsAssess.push({
        assessHeader: "Biegewechsel pro Jahr",
        assessText: this.inspections[inspIndex].assessText1,
        assess: this.inspections[inspIndex].assess1
      });
      this.itemsAssess.push({
        assessHeader: "Überrollungen pro Jahr",
        assessText: this.inspections[inspIndex].assessText2,
        assess: this.inspections[inspIndex].assess2
      });
      this.itemsAssess.push({
        assessHeader: "Personalsituation",
        assessText: this.inspections[inspIndex].assessText3,
        assess: this.inspections[inspIndex].assess3
      });
      this.itemsAssess.push({
        assessHeader: "Fahrzeugbedingungen",
        assessText: this.inspections[inspIndex].assessText4,
        assess: this.inspections[inspIndex].assess4
      });
      this.itemsAssess.push({
        assessHeader: "Höhenprofil",
        assessText: this.inspections[inspIndex].assessText5,
        assess: this.inspections[inspIndex].assess5
      });
      this.itemsAssess.push({
        assessHeader: "Anlagenerfahrungen",
        assessText: this.inspections[inspIndex].assessText6,
        assess: this.inspections[inspIndex].assess6
      });
      this.itemsAssess.push({
        assessHeader: "Umgebungsbedinungen",
        assessText: this.inspections[inspIndex].assessText7,
        assess: this.inspections[inspIndex].assess7
      });
      this.itemsAssess.push({
        assessHeader: "Betriebserfahrungen",
        assessText: this.inspections[inspIndex].assessText8,
        assess: this.inspections[inspIndex].assess8
      });
    },
    printPDF2() {
      var inspectionList = this.$store.state.inspections;

      var o = inspectionList.find(
        x => x.inspectionID === this.$store.state.inspectingID
      );
      var facName = o.facName;
      var ropeName = o.roName;
      var ropeType = o.roType;
      var firstName = this.$store.state.firstName;
      var lastName = this.$store.state.lastName;
      var date = o.date;
      var interval = o.interval;

      var clearedList = [];
      this.itemsAssess.forEach(function(element) {
        if (element.assessText.length != 0) {
          clearedList.push(element);
        }
      });

      var vm = this;
      var columns = [
        { title: "Kriterium", dataKey: "assessHeader" },
        { title: "Beschreibung", dataKey: "assessText" },
        { title: "Bewertung", dataKey: "assess" }
      ];
      var doc = new jsPDF("p", "pt");
      doc.setFontSize(22);
      doc.setFontType("bold");
      doc.text(250, 75, "Bericht");
      doc.setFontSize(12);
      doc.setFontType("normal");
      doc.line(45, 95, 45, 190);
      doc.line(555, 95, 555, 190);
      doc.line(45, 190, 555, 190);
      doc.line(45, 95, 555, 95);
      doc.text(50, 110, "Name: " + firstName + " " + lastName);
      doc.text(50, 135, "Datum: " + date.toString());
      doc.text(50, 160, "Anlage: " + facName);
      doc.text(50, 185, "Seilbezeichnung / Norm: " + ropeName);
      doc.text(50, 210, "Seilbezeichnung / Norm: " + ropeType);
      doc.setFontType("bold");
      doc.setFontSize(20);
      doc.text(190, 245, "Prüfungsintervall: " + interval);
      // doc.text(20, 100, "Name");

      doc.autoTable(columns, clearedList, {
        margin: { top: 265 },
        theme: "grid",
        columnStyles: { fillColor: [0, 0, 0] }
      });
      let finalY = doc.autoTable.previous.finalY;
      doc.setFontSize(12);
      doc.setFontType("normal");
      doc.text(200, finalY + 50, "Unterschrift:_________________");
      doc.save("Inspection.pdf");
      doc.output("Inspection.pdf");

      //   margins = { top: 40, bottom: 60, left: 40, width: 522 };

      //   var printArea = document.getElementById("dataTables-releases");

      //   pdf.addHTML(printArea, margins, function() {
      //     pdf.save("Inspection.pdf");
      //     pdf.output("Inspection.pdf");
      //   });
    },
    printPDF() {
      console.log("print pdf");
      var o = this.$store.state.inspections.find(
        x => x.inspectionID === this.$store.state.inspectingID
      );
      let ResultItems = [
        { intervall: "1 Jahr", points: "0-3", min: 0, max: 3 },
        { intervall: "6 Monate", points: "4-6", min: 4, max: 6 },
        { intervall: "3 Monate", points: "7-8", min: 7, max: 8 },
        { intervall: "2 Monate", points: "9-10", min: 9, max: 10 },
        { intervall: "1 Monat", points: "größer 10", min: 11, max: 20 }
      ];
      let ResultHeaders = [
        {
          text: "Intervall für die augenscheinlichen Inspektion",
          align: "center"
        },
        {
          text: "Punktezahl",
          align: "center"
        }
      ];

      let items = [
        { header: o.assessHeader1, name: o.assessText1, assess: o.assess1 },
        { header: o.assessHeader2, name: o.assessText2, assess: o.assess2 },
        { header: o.assessHeader3, name: o.assessText3, assess: o.assess3 },
        { header: o.assessHeader4, name: o.assessText4, assess: o.assess4 },
        { header: o.assessHeader5, name: o.assessText5, assess: o.assess5 },
        { header: o.assessHeader6, name: o.assessText6, assess: o.assess6 },
        { header: o.assessHeader7, name: o.assessText7, assess: o.assess7 },
        { header: o.assessHeader8, name: o.assessText8, assess: o.assess8 }
      ];

      var inspectionList = items;
      var resItems = ResultItems;

      var clearedList = [];
      inspectionList.forEach(function(element) {
        if (element.header.length != 0) {
          clearedList.push(element);
        }
      });
      let score =
        o.assess1 +
        o.assess2 +
        o.assess3 +
        o.assess4 +
        o.assess5 +
        o.assess6 +
        o.assess7 +
        o.assess8;
      clearedList.push({
        header: "Gesamtpunktezahl",
        name: "",
        assess: score //this.assessmen
      });

      // add arrow to result
      resItems
        .filter(x => score >= x.min && score <= x.max)
        .map(x => (x.res = "-->"));

      var facName = o.facName;
      var ropeName = o.roName;
      var ropeType = o.roType;
      var firstName = this.$store.state.firstName;
      var lastName = this.$store.state.lastName;
      var date = o.date;
      var interval = o.interval;

      var vm = this;
      var columns = [
        { title: "Kriterium", dataKey: "header" },
        { title: "Beschreibung", dataKey: "name" },
        { title: "Bewertung", dataKey: "assess" }
      ];

      var resColumns = [
        { title: "Ergebnis", dataKey: "res" },
        { title: "Gesamtauswertung", dataKey: "points" },
        {
          title: "Maximales Intervall für die Sichtprüfung",
          dataKey: "intervall"
        }
      ];

      var doc = new jsPDF("p", "pt");
      doc.setFontSize(18);
      // doc.setFontType("bold");
      doc.text(
        50,
        55,
        "Protokoll der Berechnung des Intervalls für die Sichtprüfung"
      );
      doc.text(250, 75, "an Seilen");
      doc.setFontSize(12);
      doc.setFontType("normal");
      doc.text(180, 90, "gemäß ÖNORM EN 12927:2019 (Anhang E)");
      doc.line(40, 95, 40, 215);
      doc.line(555, 95, 555, 215);
      doc.line(40, 215, 555, 215);
      doc.line(40, 95, 555, 95);
      doc.text(50, 110, "Name: " + firstName + " " + lastName);
      doc.text(
        50,
        135,
        "Datum: " + new Date(date).toLocaleDateString(["de-AT"])
      );
      doc.text(50, 160, "Anlage: " + facName);
      doc.text(50, 185, "Seilbezeichnung / Norm: " + ropeName);
      doc.text(50, 210, "Seiltyp: " + ropeType);
      doc.setFontType("bold");

      // doc.text(20, 100, "Name");

      doc.autoTable(columns, clearedList, {
        margin: { top: 230 },
        theme: "striped",
        //      headerStyles: { fillColor: [33, 150, 243] },
        columnStyles: {
          header: { cellWidth: 130 },
          name: { cellWidth: 300 },
          assess: { cellWidth: 80, halign: "center" }
        },
        allSectionHooks: true,
        willDrawCell: function(data) {
          if (data.row.raw.header === "Gesamtpunktezahl") {
            // doc.setTextColor(231, 76, 60) // Red
            doc.setFontStyle("bold");
          }
        }
      });
      doc.autoTable(resColumns, resItems, {
        columnStyles: {
          // intervall: { halign: 'right'}
        },
        styles: {
          minCellWidth: 110,
        },
        allSectionHooks: true,
        willDrawCell: function(data) {
          console.log(data);
          if (score >= data.row.raw.min && score <= data.row.raw.max) {
            // doc.setTextColor(36, 171, 24); // Green
            doc.setFontStyle("bold");
          }
        }
      });

      let finalY = doc.autoTable.previous.finalY;

      doc.setFontSize(20);
      // doc.text(80, finalY+30, "Maximales Intervall für die Sichtprüfung: " + interval);
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      doc.text("Maximales Intervall für die Sichtprüfung: " + interval, pageWidth/2, finalY+30, 'center')

      let text = 'Diese Berechnung wurde auf Grundlage der genannten Norm durchgeführt. Es wird darauf hingewiesen, dass die Vorgaben des Seilherstellers bzw. der Seilbahnbehörde zu beachten sind. Diese Berechnung kann als Vorlage für den Seilhersteller zur allfälligen Änderung von Betriebs- und Wartungsanleitungen bzw. für die Behörde zu allfälligen Anpassungen der Betriebsvorschriften dienen.';
      doc.setFontSize(10);
      doc.setFontType("normal");
      doc.text(text, 40, finalY + 50, {maxWidth: 510, align: "justify"});

      finalY = finalY + 80;
      doc.setFontSize(12);
      doc.setFontType("normal");
      doc.text(
        40,
        finalY + 50,
        "Datum:_________________                           Unterschrift:_________________"
      );

      doc.setFontSize(10);
      doc.setFontType("normal");
      doc.text(
        120,
        finalY + 90,
        "Die App für diese Berechnung wurde zur Verfügung gestellt von der"
      );
      doc.setFontType("bold");
      doc.text(
        133,
        finalY + 102,
        "Versuchsanstalt für Maschinenbau an der HTL-Anichstraße"
      );
      doc.setFontType("normal");
      doc.text(220, finalY + 114, "https://www.vamibk.at/");
      doc.save("Prüfungsintervallberechnung.pdf");
      doc.output("Prüfungsintervallberechnung.pdf");
    }
  },
  created() {
    if (this.$store.state.isOnline) {
      this.inspections = this.$store.state.inspections;
    } else {
      this.$router.push("/");
    }
  }
};
</script>

<style>
.EarlierInspections {
  background-color: white;
  width: 90%;
  margin: 5% auto 0% auto;
  border: 2px solid black;
  border-radius: 5px;
  text-align: center;
}
</style>
